import React, { ReactElement, useEffect } from 'react';
import { useDeleteEntite, useEntites } from '../../../Utils/api';
import TableSimple from '../Utils/TableSimple';
import { Colonne } from '../Utils/TypesTableSimple';
import { Lieu } from '../../../../../common/src/entities';
import { Button, ButtonGroup, Col, Dropdown, Row } from 'react-bootstrap';
import { BiPlus, BsBuilding } from 'react-icons/all';
import EnteteDePage from '../Utils/EnteteDePage';
import { LinkContainer } from 'react-router-bootstrap';
import PopoverSimple from '../../Common/PopoverSimple';
import { affichageLieu } from './DetailsLieu';
import { CopierPressePapier } from '../Utils/CopierPressePapier';

export default function Lieux(): ReactElement {
    const lieux = useEntites(Lieu);
    const [deleteLieu] = useDeleteEntite(Lieu);

    useEffect(() => {
        document.title = 'Lieux - Dashboard';
    }, []);

    const colonnes: Colonne<Lieu>[] = [
        {
            Header: 'Lieu',
            accessor: 'name',
            Cell: ({ row }) => {
                return affichageLieu(row.original);
            },
            sortType: (rowA, rowB) => {
                return rowA.original.name.localeCompare(rowB.original.name, 'fr-CA', {
                    ignorePunctuation: true,
                    numeric: true,
                });
            },
        },
        {
            accessor: 'id',
            Cell: function CellPressePapier(props: { row }) {
                const { row } = props;
                const lieu = row.original;

                return (
                    <div className="d-flex">
                        <span>
                            <CopierPressePapier
                                texte={`${lieu.adresse ? lieu.adresse : ''}, 
                                ${lieu.ville ? lieu.ville : ''} 
                                (${lieu.province ? lieu.province : ''}) 
                                ${lieu.code_postal ? lieu.code_postal : ''}`}
                            >
                                <PopoverSimple inList texte={lieu.name} titre="Adresse">
                                    <BsBuilding />
                                </PopoverSimple>
                            </CopierPressePapier>
                        </span>
                    </div>
                );
            },
        },
    ];
    return (
        <>
            <Row>
                <Col>
                    <EnteteDePage texte="Lieux" cacherBoutonRetour />
                </Col>
                <Col xs="auto">
                    <ButtonGroup>
                        <LinkContainer to="new">
                            <Button size="sm" variant="outline-primary" className="d-flex align-items-center">
                                <BiPlus /> Ajouter un lieu
                            </Button>
                        </LinkContainer>
                    </ButtonGroup>
                </Col>
            </Row>
            <TableSimple
                colonnes={colonnes}
                resultat={lieux}
                lien="id"
                hover
                affichageMenu={(value: Lieu) => (
                    <>
                        <LinkContainer to={String(value.id)}>
                            <Dropdown.Item>Modifier</Dropdown.Item>
                        </LinkContainer>
                        <Dropdown.Item className="text-danger" onClick={() => deleteLieu(value.id)}>
                            Supprimer
                        </Dropdown.Item>
                    </>
                )}
                etatInitial={{
                    sortBy: [
                        {
                            id: 'name',
                        },
                    ],
                }}
            />
        </>
    );
}
